<template>
    <v-card class="patient fill-height">
        <v-container>
            <v-form ref="surveyForm" v-model="surveyInfoValid" lazy-validation>
                <v-layout>
                    <v-flex md10 offset-md1>
                        <v-layout row class="justify-space-between">
                            <h3 class="headline mb-4">Informations sur le questionnaire</h3>
                            <survey-language-selector v-if="mode === 'create'"/>
                        </v-layout>

                        <v-select
                            v-model="type"
                            label="Type"
                            :items="getTypeLabels"
                        ></v-select>

                        <v-layout row class="align-items-center">
                            <v-text-field v-model="name" :rules="nameRules" label="Nom du questionnaire" required></v-text-field>
                            <SurveyClipboardButton :text-original="nameOriginal"/>
                        </v-layout>
                        <v-layout row class="align-items-center">
                            <v-layout class="flex-column">
                                <v-label >Instructions</v-label>
                                <wysiwyg class="my-2" v-model="instructions"></wysiwyg>
                            </v-layout>
                            <SurveyClipboardButton :text-original="instructionsOriginal"/>
                        </v-layout>
                        <v-select
                            v-model="rule"
                            label="Règle"
                            :items="getRuleLabels"
                        ></v-select>
                        <v-text-field type="number" v-model="extra" label="Extra"></v-text-field>
                        <v-checkbox v-model="isOpposite" label="Flèche évolutive opposée"></v-checkbox>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex md10 offset-md1 text-xs-right>
                        <v-btn :disabled="!surveyInfoValid" color="success" @click="validate">
                            Enregistrer
                        </v-btn>

                        <v-btn color="danger" flat @click="deleteDialog = true">
                            <v-icon>delete</v-icon> Supprimer
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-dialog v-model="deleteDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Supprimer le questionnaire</v-card-title>
                    <v-card-text>Voulez-vous vraiment supprimer ce questionnaire ?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="deleteSurvey()">Oui, supprimer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </v-card>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import SurveyClipboardButton from "./components/SurveyClipboardButton.vue";
import SurveyLanguageSelector from "./components/SurveyLanguageSelector.vue";

    export default {
        name: "SurveyForm",
        components: {SurveyLanguageSelector, SurveyClipboardButton},
        data() {
            return {
                mode: 'create',
                surveyInfoValid: false,
                nameRules: [
                    v => !!v || 'Le nom est requis'
                ],
                showStartDatePicker: false,
                showEndDatePicker: false,
                deleteDialog: false,
                startAtFormatted: '',
                endAtFormatted: '',
            }
        },
        computed: {
            ...mapState('surveys', {
                selectedSurveyId: state => state.selected_score.id,
                language: state => state.currentLanguage,
            }),
            ...mapGetters('surveys', {
                getRuleLabels: 'getRuleLabels',
                getTypeLabels: 'getTypeLabels',
            }),

            type: {
                get() {
                    return this.$store.state.surveys.form.type
                },
                set(value) {
                    this.setType(value)
                }
            },

            name: {
                get() {
                    return this.$store.state.surveys.form.name
                },
                set(value) {
                    this.setName(value)
                }
            },
            nameOriginal() {
                return this.$store.state.surveys.form.nameOriginal
            },
            instructions: {
                get() {
                    return this.$store.state.surveys.form.instructions
                },
                set(value) {
                    this.setInstructions(value)
                }
            },
            instructionsOriginal() {
                return this.$store.state.surveys.form.instructionsOriginal
            },
            rule: {
                get() {
                    return this.$store.state.surveys.form.rule
                },
                set(value) {
                    this.setRule(value)
                }
            },
            extra: {
                get() {
                    return this.$store.state.surveys.form.extra
                },
                set(value) {
                    this.setExtra(value)
                }
            },
            isOpposite: {
                get() {
                    return this.$store.state.surveys.form.is_opposite
                },
                set(value) {
                    this.setIsOpposite(value)
                }
            }

        },
        created() {
            if (this.$route.params.id) {
                this.mode = "edit"

                this.setSelectedScoreId(this.$route.params.id)
                this.loadScoreForm()
            }
            else {
                this.mode = "create"
                this.initScoreForm()
            }
        },
        mounted() {
            if (this.mode === 'create') {
                this.name = ''
            }
        },
        methods: {
            validate() {
                if (this.$refs.surveyForm.validate()) {
                    this.submit()
                }
            },
            submit() {
                if (this.mode === 'create') {
                    this.createScore().then(response => {
                        this.$router.replace({name: 'survey.view', params: {id: response.data.scoreId}})
                    }).catch(reason => {
                        //Stay here..
                    })
                } else {
                    this.updateScore().then(response => {
                        this.$router.replace({name: 'survey.view', params: {id: this.selectedSurveyId}})
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            deleteSurvey() {
                this.postDeleteScore().then(response => {
                    this.$router.replace({name: 'surveys'})
                }).catch(reason => {
                    //Stay here..
                })
            },
            ...mapMutations('surveys', {
                setType: 'setFormType',
                setName: 'setFormName',
                setStatus: 'setFormStatus',
                setInstructions: 'setFormInstructions',
                setRule: 'setFormRule',
                setExtra: 'setFormExtra',
                setIsOpposite: 'setFormIsOpposite',
                setSelectedScoreId: 'setSelectedScoreId',
                initScoreForm: 'initScoreForm',
            }),
            ...mapActions('surveys', ['createScore', 'updateScore', 'loadScoreForm', 'postDeleteScore']),
        },
        watch: {
            language() {
                if (this.$route.params.id) {
                    this.loadScoreForm()
                }
            }
        }
    }
</script>

<style scoped>

</style>
